enum LassoToolMode {
  DEFAULT,
  ADD_GROUP_PINS,
}

export default LassoToolMode;
